import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();
const sameLink = (a, b) => (a.elementId === b.elementId && a.linkedElementId === b.linkedElementId) || (a.elementId === b.linkedElementId && a.linkedElementId === b.elementId);

// Liste des liaisons de la copie après ajouts et suppressions (même règle que LinkingElementsForm) ; appliquée à la saisie puis à
// l'acceptation, sans doublon
export const applyLinkChanges = (list = [], toAdd = [], toDelete = []) => [...list.filter(link => ![...toDelete, ...toAdd].some(changed => sameLink(changed, link))), ...toAdd];

export const linkHandlers = {
    'link.toggle': {
        describe: op => i18n.t("Liaison d'éléments ({{count}})", { count: op.payload.toAdd.length + op.payload.toDelete.length }),
        buildRequest: async (op) => ({
            request: { method: 'post', url: `${BACKEND_ENDPOINT}projects/linkedElements/${op.projectId}`, data: { linkedElementsToAdd: op.payload.toAdd, linkedElementsToDelete: op.payload.toDelete } }
        }),
        onSuccess: async (op, response, context) => {
            await context.snapshot.updateList(op.projectId, 'linkedElements', list => applyLinkChanges(list, op.payload.toAdd, op.payload.toDelete));
            return {};
        }
    },
    'link.delete': {
        describe: op => i18n.t("Suppression de liaisons ({{count}})", { count: op.payload.linkedElements.length }),
        buildRequest: async (op) => ({ request: { method: 'delete', url: `${BACKEND_ENDPOINT}projects/linkedElements/${op.projectId}`, data: op.payload.linkedElements } }),
        onSuccess: async (op, response, context) => {
            await context.snapshot.updateList(op.projectId, 'linkedElements', list => applyLinkChanges(list, [], op.payload.linkedElements));
            return {};
        }
    }
};
